module.exports = __webpack_public_path__ + "static/media/sf-test-19.ad26b4c2.mp3";